import { Box, Grid2, Icon, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemSecondaryAction, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormStatusEnum } from "../../../_common/enum/forms/formStatus.enum";
import { IFormTemplateSectionList } from "../../../_common/models/formTemplateSection";
import { StandardButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";

export function FormTemplateSectionList(params: { formStatus?: FormStatusEnum }) {

    const [data, setData] = useState<Array<IFormTemplateSectionList>>([]);
    const [isLoading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [selectedSectionId, setSelectedSectionId] = useState(0);

    const { formTemplateId } = useParams<{ formTemplateId: string }>();

    let navigate = useNavigate();

    useEffect(() => {
        if (formTemplateId) fetchData();
        else setData([]);
    }, [formTemplateId]);

    function fetchData() {
        setLoading(true);
        return formTemplateSectionService
            .getAll(+(formTemplateId || 0))
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function disable(id: number) {
        setSaving(true);
        return formTemplateSectionService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    fetchData();
                }
            )
            .finally(() => setSaving(false));
    }

    return (
        <Grid2 container spacing={1}>
            <Grid2 size={{ xs: 12 }}>


                {isLoading && <LinearProgress />}

                {(data && data.length < 1 && !isLoading) &&
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ p: 1 }}>
                        <Typography color="text.secondary" fontStyle="italic">
                            No Associated Lookup values
                        </Typography>
                    </Box>
                }

                <List dense={true}>
                    {(data && data.length > 0) && data.map(item =>
                        <ListItem
                            sx={{ paddingLeft: "4px" }}
                            key={item.id}
                            disableGutters
                            secondaryAction={<>
                                <IconButton
                                    // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                    edge="end" aria-label="view" onClick={() => { navigate("/FormTemplateSections/" + item.id) }}>
                                    <Icon>visibility</Icon>
                                </IconButton>
                                <IconButton
                                    // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                    edge="end" aria-label="edit" onClick={() => { navigate("EditSection/" + item.id) }}>
                                    <Icon>edit</Icon>
                                </IconButton>

                                <IconButton
                                    // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                    edge="end" aria-label="delete" onClick={() => disable(item.id)}>
                                    <Icon>delete</Icon>
                                </IconButton>
                            </>}>
                            <ListItemText
                                primary={item.name}
                                secondary={"Section Order: " + item.sectionOrder}
                            />
                        </ListItem>

                    )}
                </List>

                <StandardButton
                    type="button"
                    icon="add"
                    loading={isLoading}
                    // disabled={isLoading || (params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess)}
                    onClick={() => { navigate(`CreateSection/`) }}>
                    Create Section
                </StandardButton>
            </Grid2>
        </Grid2>

    );
}